import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

import StudentMeets from "./pages/StudentMeets";
import BookSlot from "./pages/BookSlot";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import StudyDestination from "./pages/StudyDestination";
import UniversitiesPage from "./pages/UniversitiesPage";
import UniversityPage from "./pages/UniversityPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Loader from "./components/Loader";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import NotFound from "./pages/NotFound";
import "./styles/global.css";

/* ---------------- Scroll to Top ---------------- */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

/* ---------------- Loader Wrapper ---------------- */
function HomeLoaderWrapper({ children }) {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // If we navigate away from "/" before loader finishes, dismiss it immediately
  useEffect(() => {
    if (location.pathname !== "/") {
      setLoading(false);
    }
  }, [location.pathname]);

  if (loading && location.pathname === "/") {
    return <Loader onFinish={() => setLoading(false)} />;
  }

  return children;
}

/* ---------------- Layouts ---------------- */

// Layout WITH Navbar
function MainLayout() {
  return (
    <>
      <Navbar />
      <HomeLoaderWrapper>
        <Outlet />
      </HomeLoaderWrapper>
      <Footer />
    </>
  );
}

// Layout WITHOUT Navbar
function AdminLayout() {
  return <Outlet />;
}

/* ---------------- Routes ---------------- */
export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        {/* Public Routes with Navbar */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/student-meets" element={<StudentMeets />} />
          <Route path="/book-slot" element={<BookSlot />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          {/* ✅ slash before param, not hyphen */}
          <Route path="/study-in/:country" element={<StudyDestination />} />
          <Route path="/universities" element={<UniversitiesPage />} />
          {/* University detail pages */}
          <Route path="/university/:slug" element={<UniversityPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* Admin Route without Navbar */}
        <Route element={<AdminLayout />}>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin-login" element={<AdminLogin />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}